import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import { Card } from '@material-ui/core';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import Tooltip from '@material-ui/core/Tooltip';
import { QUESTION_TYPE } from '../../../../shared/utils/constants';

const QuestionCard = (props) => {
  const { question, t, onEditClick, onRemoveClick, hideQuestionCard } = props;

  const getOptionsList = (q) => {
    let content = null;
    if (q.answers) {
      if (q.type.value === QUESTION_TYPE.OBJECTIVE) {
        content = q.answers.map((option) => (
          <div key={option.hashId} className="question-option-line">
            {option.correct ? (
              <RadioButtonCheckedIcon fontSize="small" />
            ) : (
              <RadioButtonUncheckedIcon fontSize="small" />
            )}
            <span className="question-option">{option.description}</span>
          </div>
        ));
      } else if (q.type.value === QUESTION_TYPE.SELECTION) {
        content = q.answers.map((option) => (
          <div key={option.hashId} className="question-option-line">
            <CheckBoxOutlineBlankIcon fontSize="small" />
            <span className="question-option">{option.description}</span>
          </div>
        ));
      } else if (q.type.value === QUESTION_TYPE.TRUE_FALSE) {
        content = q.answers.map((option) => (
          <div key={option.hashId} className="question-option-line">
            {t(`answers.${option.trueOrFalse}-letter`)}
            <span className="question-option">{option.description}</span>
          </div>
        ));
      }
    }
    return content;
  };

  return (
    <MuiThemeProvider>
      {!hideQuestionCard && (
        <Card className="question-card" variant="outlined">
          <div
            className="question-description"
            dangerouslySetInnerHTML={{ __html: question.description }}
          />
          {getOptionsList(question)}

          <div className="question-actions">
            {onEditClick && (
              <Tooltip title={t('general.change')}>
                <IconButton onClick={onEditClick}>
                  <Edit fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onRemoveClick && (
              <Tooltip title={t('general.delete')}>
                <IconButton onClick={onRemoveClick}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </Card>
      )}
    </MuiThemeProvider>
  );
};

QuestionCard.propTypes = {
  question: PropTypes.shape(PropTypes.shape).isRequired,
  onEditClick: PropTypes.func,
  onRemoveClick: PropTypes.func,
  t: PropTypes.func.isRequired,
  hideQuestionCard: PropTypes.bool,
};

QuestionCard.defaultProps = {
  hideQuestionCard: false,
  onEditClick: undefined,
  onRemoveClick: undefined,
};

export default withTranslation('common')(QuestionCard);
